'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnconnectedAddressForm = undefined;

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _isPostalCode = require('validator/lib/isPostalCode');

var _isPostalCode2 = _interopRequireDefault(_isPostalCode);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _chemist = require('chemist');

var _EnterAddressForm = require('./EnterAddressForm');

var _EnterAddressForm2 = _interopRequireDefault(_EnterAddressForm);

var _SelectedAddress = require('../AddressBook/components/SelectedAddress');

var _SelectedAddress2 = _interopRequireDefault(_SelectedAddress);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _addressBook = require('../../higherOrder/addressBook');

var _addressBook2 = _interopRequireDefault(_addressBook);

var _AddressBook = require('../AddressBook');

var _AddressBook2 = _interopRequireDefault(_AddressBook);

var _EmailField = require('./EmailField');

var _EmailField2 = _interopRequireDefault(_EmailField);

var _loading = require('../../actions/loading');

var _addressBook3 = require('../../actions/addressBook');

var _presentation = require('../../actions/presentation');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterProps = function filterProps(props) {
  return _lodash2.default.pickBy(props, function (value, key) {
    return key !== 'styles';
  });
};

var showAddressBook = function showAddressBook(dispatch) {
  return function (addressBookType) {
    return function (e) {
      e.preventDefault();
      dispatch({ type: 'SHOW_ADDRESS_BOOK', addressBookType: addressBookType });
    };
  };
};

var Form = function Form(props) {
  var _props$EnterAddressFo = props.EnterAddressForm,
      EnterAddressForm = _props$EnterAddressFo === undefined ? _EnterAddressForm2.default : _props$EnterAddressFo;


  return _react2.default.createElement(
    props.Container,
    null,
    _react2.default.createElement(EnterAddressForm, filterProps(props))
  );
};

var AddressForm = (_dec = (0, _chemist.configurable)(), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(AddressForm, _React$Component);

  function AddressForm() {
    (0, _classCallCheck3.default)(this, AddressForm);
    return (0, _possibleConstructorReturn3.default)(this, (AddressForm.__proto__ || (0, _getPrototypeOf2.default)(AddressForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(AddressForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.isAddressBookAvailable && !this.props.isAddressBookAvailable()) {
        return;
      }

      this.props.dispatch((0, _presentation.hideAddressBook)());

      var addressBookState = this.props.addressBook || { populated: false };
      if (!addressBookState.populated) {
        this.props.dispatch((0, _loading.setLoading)());
        this.props.dispatch((0, _addressBook3.queryAddressBook)());
        return;
      }

      this.props.dispatch((0, _loading.clearLoading)());
    }
  }, {
    key: 'hideAddressBook',
    value: function hideAddressBook() {
      var unavailable = !this.props.isAddressBookAvailable();
      var noSavedAddresses = this.props.getAddresses().length < 1;

      return this.props.config.theme !== 'painters' || unavailable || noSavedAddresses;
    }
  }, {
    key: 'render',
    value: function render() {
      return this.hideAddressBook() ? _react2.default.createElement(Form, this.props) : _react2.default.createElement(SelectedAddresses, this.props);
    }
  }]);
  return AddressForm;
}(_react2.default.Component)) || _class);
var SelectedAddresses = (_temp = _class2 = function (_React$Component2) {
  (0, _inherits3.default)(SelectedAddresses, _React$Component2);

  function SelectedAddresses() {
    (0, _classCallCheck3.default)(this, SelectedAddresses);
    return (0, _possibleConstructorReturn3.default)(this, (SelectedAddresses.__proto__ || (0, _getPrototypeOf2.default)(SelectedAddresses)).apply(this, arguments));
  }

  (0, _createClass3.default)(SelectedAddresses, [{
    key: 'getSelectedAddressId',
    value: function getSelectedAddressId() {
      var type = this.props.addressBookType;

      return this.props.selectedAddressIds[type] || this.getLastSelectedAddressOfType(type).id;
    }
  }, {
    key: 'getLastSelectedAddressOfType',
    value: function getLastSelectedAddressOfType(type) {
      return this.props.getSelectedAddress(type) || this.props.getAddresses()[0];
    }
  }, {
    key: 'renderAddressBook',
    value: function renderAddressBook() {
      var _this3 = this;

      if (!this.props.addressBookVisible) return _react2.default.createElement('span', null);

      var selectedAddressId = this.getSelectedAddressId();
      var addresses = this.props.getAddresses().map(function (address) {
        return {
          id: address.id,
          firstName: address.firstname,
          lastName: address.lastname,
          company: address.company,
          address1: address.address1,
          address2: address.address2,
          city: address.city,
          state: address.stateName,
          postcode: address.zipcode,
          phone: address.phone
        };
      });

      return _react2.default.createElement(_AddressBook2.default, {
        page: this.props.addressBookPage,
        addressType: this.props.addressBookType,
        addresses: addresses,
        selectedAddressId: selectedAddressId,
        editingAddressId: this.props.addressBookEditId,
        onAdd: function onAdd() {
          _this3.props.dispatch((0, _presentation.setAddressBookPage)('AddAddress'));
        },
        onCreate: function onCreate(e) {
          e.preventDefault();
          var address = {};
          var formEntries = new FormData(e.target).entries();
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(formEntries), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var entry = _step.value;
              address[entry[0]] = entry[1];
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          address.AddressBookAddressType = [_this3.props.addressBookType];

          if (!(0, _isPostalCode2.default)(address.AddressBookPostcode, _this3.props.config.store.countryCode)) {
            _this3.props.dispatch((0, _addressBook3.setPostcodeError)());
            return;
          }

          _this3.props.dispatch((0, _addressBook3.removePostcodeError)());
          _this3.props.createAddress(address).then(function () {
            _this3.props.dispatch((0, _addressBook3.queryAddressBook)()).then(function () {
              var _props$getAddresses$s = _this3.props.getAddresses().slice(-1),
                  _props$getAddresses$s2 = (0, _slicedToArray3.default)(_props$getAddresses$s, 1),
                  lastAddress = _props$getAddresses$s2[0];

              if (lastAddress) {
                _this3.props.dispatch((0, _presentation.setChosenAddress)(_this3.props.addressBookType, lastAddress.id));

                var formedAddress = {
                  AddressBookId: lastAddress.id,
                  AddressBookFirstName: lastAddress.firstname,
                  AddressBookLastName: lastAddress.lastname,
                  AddressBookCompany: lastAddress.company,
                  AddressBookAddressLine1: lastAddress.address1,
                  AddressBookAddressLine2: lastAddress.address2,
                  AddressBookCity: lastAddress.city,
                  AddressBookPostcode: lastAddress.zipcode,
                  AddressBookState: lastAddress.stateName,
                  AddressBookPhone: lastAddress.phone,
                  AddressBookAddressType: [_this3.props.addressBookType]
                };

                _this3.props.updateAddress(formedAddress).then(function () {
                  _this3.props.dispatch((0, _addressBook3.queryAddressBook)());
                  _this3.props.dispatch((0, _loading.setLoading)());
                  _this3.props.dispatch((0, _presentation.hideAddressBook)());
                });
              }
            });

            _this3.props.dispatch((0, _loading.setLoading)());
            _this3.props.dispatch((0, _presentation.hideAddressBook)());
          });
        },
        onEdit: function onEdit(addressId) {
          return function () {
            _this3.props.dispatch((0, _presentation.editAddress)(addressId));
          };
        },
        onUpdate: function onUpdate(e) {
          e.preventDefault();
          var address = {};
          var formEntries = new FormData(e.target).entries();
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = (0, _getIterator3.default)(formEntries), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var entry = _step2.value;
              address[entry[0]] = entry[1];
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (!(0, _isPostalCode2.default)(address.AddressBookPostcode, _this3.props.config.store.countryCode)) {
            _this3.props.dispatch((0, _addressBook3.setPostcodeError)());
            return;
          }

          _this3.props.dispatch((0, _addressBook3.removePostcodeError)());
          _this3.props.updateAddress(address).then(function () {
            _this3.props.dispatch((0, _addressBook3.queryAddressBook)());
            _this3.props.dispatch((0, _loading.setLoading)());
            _this3.props.dispatch((0, _presentation.hideAddressBook)());
          });
        },
        onChoice: function onChoice(e) {
          _this3.props.dispatch((0, _presentation.setChosenAddress)(_this3.props.addressBookType, parseInt(e.currentTarget.value, 10)));
        },
        onSelect: function onSelect() {
          var address = _lodash2.default.find(addresses, { id: parseInt(selectedAddressId, 10) });
          var formedAddress = {
            AddressBookId: address.id,
            AddressBookFirstName: address.firstName,
            AddressBookLastName: address.lastName,
            AddressBookCompany: address.company,
            AddressBookAddressLine1: address.address1,
            AddressBookAddressLine2: address.address2,
            AddressBookCity: address.city,
            AddressBookPostcode: address.postcode,
            AddressBookState: address.state,
            AddressBookPhone: address.phone,
            AddressBookAddressType: [_this3.props.addressBookType]
          };

          _this3.props.updateAddress(formedAddress).then(function () {
            _this3.props.dispatch((0, _addressBook3.queryAddressBook)());
            _this3.props.dispatch((0, _loading.setLoading)());
            _this3.props.dispatch((0, _presentation.hideAddressBook)());
          });
        },
        onDelete: function onDelete(addressId) {
          return function (e) {
            e.preventDefault();
            _this3.props.deleteAddress(addressId).then(function () {
              _this3.props.dispatch((0, _addressBook3.queryAddressBook)());

              _lodash2.default.map(['shipping', 'billing'], function (addressType) {
                var selectedAddress = _this3.props.getSelectedAddress(addressType);

                if (addressId === selectedAddress.id) {
                  var availableAddresses = _this3.props.getAddresses();

                  if (availableAddresses.length > 0) {
                    var address = availableAddresses[0];
                    _this3.props.dispatch((0, _presentation.setChosenAddress)(addressType, address.id));

                    var formedAddress = {
                      AddressBookId: address.id,
                      AddressBookFirstName: address.firstName,
                      AddressBookLastName: address.lastName,
                      AddressBookCompany: address.company,
                      AddressBookAddressLine1: address.address1,
                      AddressBookAddressLine2: address.address2,
                      AddressBookCity: address.city,
                      AddressBookPostcode: address.postcode,
                      AddressBookState: address.state,
                      AddressBookPhone: address.phone,
                      AddressBookAddressType: [addressType]
                    };

                    _this3.props.updateAddress(formedAddress).then(function () {
                      _this3.props.dispatch((0, _loading.setLoading)());
                      _this3.props.dispatch((0, _addressBook3.queryAddressBook)());
                      _this3.props.dispatch((0, _loading.clearLoading)());
                    });
                  }
                }
              });
            });
          };
        },
        onCancel: function onCancel() {
          _this3.props.dispatch((0, _presentation.setAddressBookPage)('AddressList'));
          _this3.props.dispatch((0, _addressBook3.removePostcodeError)());
        },
        onClose: function onClose() {
          var lastAddress = _this3.getLastSelectedAddressOfType(_this3.props.addressBookType);
          _this3.props.dispatch((0, _presentation.hideAddressBook)());
          _this3.props.dispatch((0, _addressBook3.removePostcodeError)());
          _this3.props.dispatch((0, _presentation.setChosenAddress)(_this3.props.addressBookType, lastAddress.id));
        }
      });
    }
  }, {
    key: 'renderSelectedAddresses',
    value: function renderSelectedAddresses() {
      var shipAddress = this.props.getSelectedAddress('shipping');
      var billAddress = this.props.getSelectedAddress('billing');

      return _react2.default.createElement(
        'div',
        { className: 'selected-addresses' },
        _react2.default.createElement(_EmailField2.default, filterProps(this.props)),
        _react2.default.createElement(_SelectedAddress2.default, {
          type: 'shipping',
          firstName: shipAddress.firstname,
          lastName: shipAddress.lastname,
          company: shipAddress.company,
          address1: shipAddress.address1,
          address2: shipAddress.address2,
          city: shipAddress.city,
          state: shipAddress.stateName,
          postcode: shipAddress.zipcode,
          phone: shipAddress.phone,
          onChooseAddress: showAddressBook(this.props.dispatch)
        }),
        _react2.default.createElement(_SelectedAddress2.default, {
          type: 'billing',
          firstName: billAddress.firstname,
          lastName: billAddress.lastname,
          company: billAddress.company,
          address1: billAddress.address1,
          address2: billAddress.address2,
          city: billAddress.city,
          state: billAddress.stateName,
          postcode: billAddress.zipcode,
          phone: billAddress.phone,
          onChooseAddress: showAddressBook(this.props.dispatch)
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.addressBook.populated) return _react2.default.createElement('span', null);

      return _react2.default.createElement(
        'div',
        null,
        this.renderAddressBook(),
        _react2.default.createElement(
          this.props.Container,
          null,
          this.renderSelectedAddresses()
        )
      );
    }
  }]);
  return SelectedAddresses;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  errors: _react.PropTypes.object,
  country: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  addressBookType: _react.PropTypes.string,
  selectedAddressIds: _react.PropTypes.shape({
    billing: _react.PropTypes.number,
    shipping: _react.PropTypes.number
  }),
  onGetAddresses: _react.PropTypes.func.isRequired,
  onGetAddress: _react.PropTypes.func.isRequired,
  shipAddresses: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.string,
    label: _react.PropTypes.string
  })),
  shipAddressDetail: _react.PropTypes.shape({
    address_1: _react.PropTypes.string,
    address_2: _react.PropTypes.string,
    city: _react.PropTypes.string
  }),
  billAddresses: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.string,
    label: _react.PropTypes.string
  })),
  billAddressDetail: _react.PropTypes.shape({
    address_1: _react.PropTypes.string,
    address_2: _react.PropTypes.string,
    city: _react.PropTypes.string
  })
}, _temp);
var UnconnectedAddressForm = exports.UnconnectedAddressForm = (0, _reactCssModules2.default)(_style2.default, { allowMultiple: true })(AddressForm);

exports.default = (0, _addressBook2.default)(UnconnectedAddressForm);


//////////////////
// WEBPACK FOOTER
// ./shared/components/AddressForm/index.js
// module id = 2444
// module chunks = 0